export default __webpack_public_path__ + "static/media/distribution.ecd53f69.png";